/**
 * Lógica de la portada del 11.11 (odd/tasks/portada-11-11.md). Funciones puras: la hora llega
 * como argumento para poder probarlas sin reloj.
 */

export interface CuentaAtras {
  fase: 'antes' | 'durante' | 'despues';
  dias: number;
  horas: number;
  minutos: number;
}

/** Etiquetas del 11.11 (utils/landing-tags: 11-11/). */
export const ETIQUETAS_ONCE_ONCE = '451,488,2019';

const MINUTO = 60_000;

/**
 * Inicio del 11.11 de 2026: domingo 01/11 00:00 hora de Madrid (UTC+1). Desde ese día todos los
 * chollos de AliExpress llevan la etiqueta 451 «11.11 Aliexpress» (02/11/2026, «acaba en»).
 */
export const INICIO_ONCE_ONCE = Date.UTC(2026, 9, 31, 23, 0, 0);

/**
 * El 11.11 va del domingo 01/11 00:00 al 18/11 23:59 hora de Madrid (en noviembre, UTC+1): la
 * promo se alarga hasta el 18 (02/11/2026, «La Promo Termina: 18 nov., 23:59 (CET)»). Antes cuenta hasta el inicio («Empieza en»); durante, hasta el final («Acaba en»); después no
 * hay cuenta.
 */
export function cuentaAtras(ahora: number): CuentaAtras {
  const anio = new Date(ahora).getUTCFullYear();
  const inicio = Date.UTC(anio, 9, 31, 23, 0, 0);
  const fin = Date.UTC(anio, 10, 18, 23, 0, 0);
  if (ahora >= fin) return { fase: 'despues', dias: 0, horas: 0, minutos: 0 };
  const fase = ahora < inicio ? 'antes' : 'durante';
  const quedan = Math.floor(((fase === 'antes' ? inicio : fin) - ahora) / MINUTO);
  return { fase, dias: Math.floor(quedan / 1440), horas: Math.floor((quedan % 1440) / 60), minutos: quedan % 60 };
}

/** Los `n` de más grados (`kmh`), los vigentes por delante; no toca la lista. */
export function masGrados<T extends { kmh?: number; status?: string }>(lista: T[] | null | undefined, n = 3): T[] {
  return [...(lista || [])]
    .sort((a, b) => Number(b.status === 'active') - Number(a.status === 'active') || (b.kmh ?? 0) - (a.kmh ?? 0))
    .slice(0, n);
}

/**
 * Los `n` de más grados creados desde `desde` (02/11/2026: «que los que salen ahí sean los de
 * esta semana»). Si no hay ninguno, los de más grados de la lista, para no dejar el bloque vacío.
 */
export function masGradosDesde<T extends { kmh?: number; status?: string; created_at?: string }>(
  lista: T[] | null | undefined, desde: number, n = 3,
): T[] {
  const recientes = (lista || []).filter(c => Date.parse(c.created_at ?? '') >= desde);
  return masGrados(recientes.length ? recientes : lista, n);
}

/** El primer cupón con código de un chollo, o `null`. */
export function cuponDe(chollo: { coupons?: { code?: string; text?: string }[] | null }): { code: string; text?: string } | null {
  const cupon = (chollo?.coupons || []).find(c => c?.code?.trim());
  return cupon ? { code: cupon.code!.trim(), text: cupon.text } : null;
}
